import React, { useMemo } from 'react';

export const SplitLines: React.FC<{ children: string }> = ({ children }) => {
	const content = useMemo(() => {
		if (typeof children === 'string') {
			return children
				.split('\n')
				.map((part) => part.trim())
				.filter((part) => !!part)
				.map((part) => <p key={part}>{part}</p>);
		}

		return children;
	}, [children]);

	return <>{content}</>;
};
